export default "__VITE_ASSET__Ca9WMQ4$__"